import * as React from "react";
import ReactPDF, { View, Text } from "@react-pdf/renderer";
import Report6PDFTemplateReportsGrid from "./Report6PDFTemplateReportsGrid";
import { TReport6ReportingPeriodPresentationModel } from "../../../presenter/report/model/Report6ReportingPeriodPresentationModel";

const Report6PDFTemplateReportingPeriod = ({
  translate,
  reportingPeriod,
  styles
}: {
  translate: any;
  reportingPeriod: TReport6ReportingPeriodPresentationModel;
  styles: ReactPDF.Styles;
}) => {
  return (
    <View style={styles.titleCol}>
      <Text style={styles.subtitle}>
        {`${translate("report6_preview_reporting_period.name")}: ${
          reportingPeriod.name
        }`}
      </Text>
      <Text style={styles.regularText}>
        {`${translate(
          "report6_preview_reporting_period.additional_evaluation"
        )}: ${
          reportingPeriod.additionalEvaluation
            ? translate("basic.yes")
            : translate("basic.no")
        }`}
      </Text>
      <Text style={styles.regularText}>
        {`${translate(
          "report6_preview_reporting_period.additional_evaluation_date"
        )}: ${reportingPeriod.additionalEvaluationDate}`}
      </Text>
      <Text style={styles.regularText}>{`${translate(
        "report6_preview_reporting_period.additional_evaluation_reason"
      )}: ${reportingPeriod.additionalEvaluationReason || ""}`}</Text>
      <Report6PDFTemplateReportsGrid
        translate={translate}
        reportingPeriod={reportingPeriod}
        styles={styles}
      ></Report6PDFTemplateReportsGrid>
    </View>
  );
};

export default Report6PDFTemplateReportingPeriod;
